import Vue from 'vue';
import VueRouter, { RouteConfig, Route } from 'vue-router';

import { Session } from '../utils/Session';

import { adminRouters } from './admin';
import { studentRouters } from './student';
import { teacherRouters } from './teacher';

const DemoPage = () => import(/* webpackChunkName: "DemoPage" */ '../views/DemoPage.vue');
// import DemoPage from '../views/DemoPage.vue';
const CommonCalendar = () => import(/* webpackChunkName: "CommonCalendar" */ '../components/organisms/CommonCalendar.vue');
// import CommonCalendar from '../components/organisms/CommonCalendar.vue';
const TopPage = () => import(/* webpackChunkName: "TopPage" */ '../views/TopPage.vue');
// import TopPage from '../views/TopPage.vue';
const ForgotPasswordPage = () => import(/* webpackChunkName: "ForgotPasswordPage" */ '../views/ForgotPasswordPage.vue');
// import ForgotPasswordPage from '../views/ForgotPasswordPage.vue';

const EntranceStudentPage = () => import(/* webpackChunkName: "EntranceStudentPage" */ '../views/EntranceStudentPage.vue');
const NewStudentPage = () => import(/* webpackChunkName: "NewStudentPage" */ '../views/NewStudentPage.vue');

const EntrancePage = () => import(/* webpackChunkName: "EntrancePage" */ '../views/EntrancePage.vue');
// import EntrancePage from '../views/EntrancePage.vue';

const EntrancePageDA = () => import(/* webpackChunkName: "EntrancePageDA" */ '../views/EntrancePageDA.vue');
// import EntrancePageDA from '../views/EntrancePageDA.vue';
const LoginByMailPage = () => import(/* webpackChunkName: "LoginByMailPage" */ '../components/login/LoginByMailPage.vue');
// import LoginByMailPage from '../components/login/LoginByMailPage.vue';
const StudentRegistPage = () => import(/* webpackChunkName: "StudentRegistPage" */ '../views/StudentRegistPage.vue');
// import StudentRegistPage from '../views/StudentRegistPage.vue';

Vue.use(VueRouter);
const routes: Array<any> = [
  // const routes: Array<RouteConfig> = [

  {
    path: '/',
    name: 'TopPage',
    component: TopPage,
  },
  {
    path: '/admin',
    name: 'DemoPage',
    component: DemoPage,
  },
  {
    path: '/entrance-page',
    name: 'EntrancePage',
    component: EntrancePage,
  },
  {
    path: '/entrance-student-page',
    name: 'EntranceStudentPage',
    component: EntranceStudentPage,
  },
  {
    path: '/new-student-page',
    name: 'NewStudentPage',
    component: NewStudentPage,
  },

  {
    path: '/student-regist-page',
    name: 'StudentRegistPage',
    component: StudentRegistPage,
  },
  {
    path: '/entrance-page-da',
    name: 'EntrancePageDA',
    component: EntrancePageDA,
  },
  {
    path: '/common-calendar',
    name: 'CommonCalendar',
    component: CommonCalendar,
  },
  {
    path: '/forgot-password-page',
    name: 'ForgotPasswordPage',
    component: ForgotPasswordPage,
  },
  {
    path: '/login-by-mail-page',
    name: 'LoginByMailPage',
    component: LoginByMailPage,
  },
]
  .concat(adminRouters)
  .concat(studentRouters)
  .concat(teacherRouters);

const router = new VueRouter({
  mode: 'hash', // "history", //mode: "hash",
  base: process.env.BASE_URL!,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

/**
 * ユーザータイプによって、ログインページが異なる。
 * 認証なしで入ろうとした時にログインページへ飛ばす。
 * @param type
 * @param to
 */
const getLoginPagePath = (type: string, to: Route, building: string) => {
  let path = '/home';
  if (type === 'student') {
    path = '/student-login-page';
  } else if (type === 'teacher') {
    path = '/teacher-login-page';
  } else if (type === 'admin') {
    path = '/admin-login-page';
  } else if (type === 'message') {
    // const reciever_type: RecieverType = to.params.reciever_type as RecieverType;
    // let rtype = '';
    // switch (reciever_type) {
    //   case 'a':
    //     rtype = 'admin';
    //     break;
    //   case 's':
    //     rtype = 'student';
    //     break;
    //   case 't':
    //     rtype = 'teacher';
    //     break;
    // }
    // path = getLoginPagePath(rtype, to);
  }
  path = path + `?building=${building}`;

  return path;
};

router.beforeEach((to, from, next) => {
  // console.log('routing', to.fullPath, to.meta, to.matched);

  // メタデータがなければnextに飛ばす（管理対象外のページ）
  if (!to.meta) {
    next();
    return;
  }

  // 認証されていなければログイン画面出す
  if (to.meta.requireAuth && !Session.isAuthorized) {
    // クエリストリングから校舎を取得
    const building = to.query.building as string;
    console.log('beforeEach', to.fullPath, to.query, building);
    if (!building) {
      console.error('校舎が取得できません');
      // Session.timeout();
      location.href = '/';
      // throw new Error('校舎が取得できません');
    }

    // どのログイン画面に返すかを判定
    const path = getLoginPagePath(to.meta.type, to, building);

    next({ path: path, query: { redirect: to.fullPath } });
  }
  // もっと厳密にログイン済みかどうかを見るにはto.matched.someでマッチするパスをチェックするっぽいが、、、
  // if(to.matched.some(record => return record.meta.requireAuth && !Session.isAuthorized )){ }
  next();
});

export default router;
